import React, { createContext } from 'react';

const NavTaxiSelectContext = createContext('all');
// console.log('NavTaxiSelectContext created : ', NavTaxiSelectContext);
export default NavTaxiSelectContext;